
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcGraphMini as ObcGraphMiniElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/graph-mini/graph-mini.js';
 
 
 

 
 export const ObcGraphMini = createComponent({
   react: React,
   tagName: 'obc-graph-mini',
   elementClass: ObcGraphMiniElement,
   events: {
     
   }
  });
 
 